export default Object.freeze({
  AUTO_RESOLVED: 'AUTO_RESOLVED',
  REVIEWED: 'REVIEWED',
  REVIEW_NEEDED: 'REVIEW_NEEDED',
});
